"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { getNftActivity, getNftHolders } from "../api";
import type { NftActivityItem, NftHolderItem } from "../types";
type Args = {
  contractAddress: string;
  tokenId: string;
  lang: "fa" | "en";
};

/** The token's sales — the legacy activity tab's query, unchanged (key, fetcher, 30s). */
export function useNftActivity(t0) {
  const $ = _c(15);
  const {
    contractAddress,
    tokenId,
    lang
  } = t0;
  let t1;
  if ($[0] !== contractAddress || $[1] !== tokenId) {
    t1 = ["nft-activity", contractAddress, tokenId];
    $[0] = contractAddress;
    $[1] = tokenId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== contractAddress || $[4] !== lang || $[5] !== tokenId) {
    t2 = () => getNftActivity(contractAddress, tokenId, lang);
    $[3] = contractAddress;
    $[4] = lang;
    $[5] = tokenId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = {
      queryKey: t1,
      queryFn: t2,
      staleTime: 30000
    };
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const query = useQuery(t3);
  let t4;
  if ($[10] !== query.data?.data?.list) {
    t4 = query.data?.data?.list ?? [];
    $[10] = query.data?.data?.list;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const activities = t4;
  let t5;
  if ($[12] !== activities || $[13] !== query) {
    t5 = {
      ...query,
      activities
    };
    $[12] = activities;
    $[13] = query;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}

/** Who holds the token — the legacy holders tab's query (key, fetcher, 60s) and its share of what is shown. */
export function useNftHolders(t0) {
  const $ = _c(18);
  const {
    contractAddress,
    tokenId,
    lang
  } = t0;
  let t1;
  if ($[0] !== contractAddress || $[1] !== tokenId) {
    t1 = ["nft-holders", contractAddress, tokenId];
    $[0] = contractAddress;
    $[1] = tokenId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== contractAddress || $[4] !== lang || $[5] !== tokenId) {
    t2 = () => getNftHolders(contractAddress, tokenId, lang);
    $[3] = contractAddress;
    $[4] = lang;
    $[5] = tokenId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = {
      queryKey: t1,
      queryFn: t2,
      staleTime: 60000
    };
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const query = useQuery(t3);
  let t4;
  if ($[10] !== query.data?.data?.holders) {
    t4 = query.data?.data?.holders ?? [];
    $[10] = query.data?.data?.holders;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const holders = t4;
  let t5;
  if ($[12] !== holders) {
    t5 = holders.reduce(_temp, 0);
    $[12] = holders;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const totalOwned = t5;
  let t6;
  if ($[14] !== holders || $[15] !== query || $[16] !== totalOwned) {
    t6 = {
      ...query,
      holders,
      totalOwned
    };
    $[14] = holders;
    $[15] = query;
    $[16] = totalOwned;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}
function _temp(sum, h) {
  return sum + Number(h.balance || 0);
}